import keys from 'lodash/keys';

export const PHASE_LABELS = {
  Scheduling: 'Scheduling',
  PreOp: 'Pre-Op',
  IntraOp: 'Intra-Op',
  Surgeon: 'Surgeon',
} as const;

export type PhaseKey = keyof typeof PHASE_LABELS;

export const getPhaseKeys = (): PhaseKey[] => (keys(PHASE_LABELS) as PhaseKey[]);